import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { bloomCardMotion } from './motion';
import { bloomChromeTone } from './palette';

export const bloomTheme: FlowThemeDefinition = {
  id: 'bloom',
  label: 'Bloom',
  description: 'A lotus bud on still water opens ring by ring as the sun rises behind it.',
  category: 'classic',
  chromeTone: bloomChromeTone,
  swatch: 'linear-gradient(180deg, #CFC6E6 0%, #F2D6CF 55%, #A39CC4 100%)',
  cardGlass: 'default',
  cardMotion: bloomCardMotion,
  burstSize: 320,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createBloomScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
